// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import React from 'react';

export interface TablePaginationIconProps {
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  'aria-label'?: string;
  'aria-hidden'?: boolean;
}

const DEFAULT_COLOR = '#868C99';

export const TablePaginationFirstIcon: React.FC<TablePaginationIconProps> = ({
  color = DEFAULT_COLOR,
  className,
  style,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden,
}) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role={ariaLabel ? 'img' : undefined}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden ?? !ariaLabel}
  >
    <line x1="1" y1="9" x2="1" y2="1" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M8.5 9L4.5 5L8.5 1" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const TablePaginationPrevIcon: React.FC<TablePaginationIconProps> = ({
  color = DEFAULT_COLOR,
  className,
  style,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden,
}) => (
  <svg
    width="7"
    height="10"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role={ariaLabel ? 'img' : undefined}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden ?? !ariaLabel}
  >
    <path d="M5.41528 9L1.41528 4.69231L5.41528 1" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const TablePaginationNextIcon: React.FC<TablePaginationIconProps> = ({
  color = DEFAULT_COLOR,
  className,
  style,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden,
}) => (
  <svg
    width="7"
    height="10"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role={ariaLabel ? 'img' : undefined}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden ?? !ariaLabel}
  >
    <path d="M1 1L5 5.30769L1 9" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const TablePaginationLastIcon: React.FC<TablePaginationIconProps> = ({
  color = DEFAULT_COLOR,
  className,
  style,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden,
}) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role={ariaLabel ? 'img' : undefined}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden ?? !ariaLabel}
  >
    <line x1="8.5" y1="1" x2="8.5" y2="9" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M1 1L5 5L1 9" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const DropdownChevronIcon: React.FC<TablePaginationIconProps> = ({
  color = DEFAULT_COLOR,
  className,
  style,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden,
}) => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role={ariaLabel ? 'img' : undefined}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden ?? !ariaLabel}
  >
    <path d="M9 1L4.69231 5L1 1" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);
